import React, { useState } from 'react';
import { Tooltip } from '@drip/drip-design';
import { FullscreenOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import { getQuery } from '@/common/utils';
import { getRootPath } from '@/pages/platform-marketing-position/resource-detail/util';
// import { queryDucc } from '@/apis/marketingField/materialCollection';
import SalePlaySelectCards from '../pandora-cards';
import PalletCardSelect from '../../../../pallet-card-list';
import TfLaunch from '@/micro-app/tf-launch';

import './index.less';

const prefix = 'tabs-wrapper';

const tabList = ['素材策略选品选店', 'BI自动选品', '平台营销货盘'];

export interface strategyItem {
  name: string;
  poolType: string;
  scene: string;
  picUrl: string;
  background: string;
  materialType: string;
}
interface ITabsWrapper {
  toSalePlaySelect: (poolType: number, materialType?: string) => void;
  toSalePlaySelectAndPromotionId: (data: { planCode: string; poolType: string }) => void;
  handleFullScreen: () => void;
  isDaily: boolean;
  listinfo: { loading: boolean; list: strategyItem[] };
}

const TabsWrapper = (props: ITabsWrapper) => {
  const { toSalePlaySelect, isDaily, toSalePlaySelectAndPromotionId, handleFullScreen, listinfo } = props;
  const [activeTab, setActiveTab] = useState('1');
  const [showNew, setShowNew] = useState(false);

  const activityId = getQuery('activityId') || '';
  const planCode = 'HD202112102036523447';

  /* 这些数据直接父级传过来 */
  // const [listinfo, setListInfo] = useState<{ loading: boolean; list: strategyItem[] }>({
  //   loading: false,
  //   list: [],
  // });
  // useEffect(() => {
  //   setListInfo({ loading: true, list: [] });
  //   const isDevelop = ['test1.yx.jd.com', 'localhost.jd.com:10000'].indexOf(window.location.host) > -1;
  //   const params = isDevelop ? 'sourceCms.yth.regular.selection.beta' : 'sourceCms.yth.regular.selection';
  //   queryDucc({ duccKey: params })
  //     .then((res) => {
  //       const { ret, msg, data } = res;
  //       if (ret === '0') {
  //         try {
  //           const data1 = JSON.parse(data?.data) || [];
  //           setListInfo({
  //             loading: false,
  //             list: [
  //               ...data1,
  //               {
  //                 name: '通用精选底池',
  //                 poolType: '53',
  //                 description: '以全站精选店铺为底池，支持多规则选店。多场景复用',
  //                 scene: '频道、活动页',
  //                 materialType: '5',
  //                 picUrl: 'https://storage.360buyimg.com/launch/launch-pandora/common_shop_100x154.png',
  //                 background: 'linear-gradient(rgba(255,248,247,1), rgba(255,255,255,0.5))',
  //               },
  //             ],
  //           });
  //         } catch (error) {
  //           setListInfo({ loading: false, list: [] });
  //         }
  //       } else {
  //         throw msg || '促销选品配置信息获取错误！';
  //       }
  //     })
  //     .catch((ex) => {
  //       message.error(ex);
  //       setListInfo({ loading: false, list: [] });
  //     });
  // }, []);

  const microData = isDaily
    ? {
        bindGroup: true,
        navbar: 'hide',
        customEdit: true,
        jumpTo: 'WDSC',
        yxActivityId: getQuery('activityId'),
        outId: getQuery('roomId'),
        materialCount: 'hide',
      }
    : {
        bindGroup: true,
        navbar: 'hide',
        customEdit: true,
        platformChannelType: getRootPath() === 'platform-marketing' ? 1 : 2,
        jumpTo: 'SCSC',
        yxActivityId: activityId,
        resourceId: getQuery('resourceId'),
        outId: getQuery('channelId'),
        materialCount: 'hide',
      };

  return (
    <div className={`${prefix}-container`}>
      <ul className={`${prefix}-tabs`}>
        {tabList.map((item, index) => (
          <li
            key={index}
            className={activeTab === `${index + 1}` ? `${prefix}-tab active` : `${prefix}-tab`}
            onClick={() => setActiveTab(`${index + 1}`)}
          >
            {item}
            {index === 2 && showNew && <span className="icon" />}
          </li>
        ))}
      </ul>
      {activeTab === '1' && (
        <>
          <div className={`${prefix}-title`} style={{ marginBottom: 0 }}>
            <h3>
              通用策略
              <Tooltip title="通用策略：精选商品，店铺，内容和频道等底池，不区分业务场景。支持各业务按不同运营策略选择不同类型的商品，店铺，内容和频道等底池，叠加选品/店/内容/频道规则，生成商品组/广告组进行素材关联使用。各底池范围见底池简介。">
                <QuestionCircleOutlined />
              </Tooltip>
            </h3>
            <div className="fullScreen">
              <span className="icon" onClick={handleFullScreen}>
                <FullscreenOutlined />
                全屏查看
              </span>
            </div>
          </div>
          <SalePlaySelectCards
            toSalePlaySelectAndPromotionId={toSalePlaySelectAndPromotionId}
            toSalePlaySelect={toSalePlaySelect}
            planCode={planCode!}
            listinfo={listinfo}
          />
        </>
      )}
      {activeTab === '2' && <TfLaunch inhash="/pandora-goods-pool" data={microData} onDataChange={(e: any) => {}} />}
      {activeTab === '3' && (
        <>
          <div className={`${prefix}-title`}>
            <h3>
              平台营销货盘
              <Tooltip
                title="①符合集团战略/流量扶持 ②有明确的业务/战略负责人 
                       ③对C端用户有明确心智表达（打标/腰带、中心化流量供给）
                       ④货盘可被规则化表达"
              >
                <QuestionCircleOutlined className={`${prefix}-icon`} />
              </Tooltip>
              <span className={`${prefix}-sub-title`}>在京东App 有固定频道露出或首页有推荐坑位的货盘</span>
            </h3>
          </div>

          <PalletCardSelect
            handlePalletSelect={toSalePlaySelect}
            isDaily={isDaily}
            handleShowNew={(flag: boolean) => setShowNew(flag)}
          />
        </>
      )}
    </div>
  );
};

export default TabsWrapper;
